import { render, staticRenderFns } from "./DocplannerSettings.vue?vue&type=template&id=ec5b970e&"
import script from "./DocplannerSettings.vue?vue&type=script&lang=js&"
export * from "./DocplannerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports